export default __webpack_public_path__ + "75b286d4200960b35745d576b45d0173.svg";